import React from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { useDisableIntegration } from "../../../../api/integrations/disable-integration";
import { usePutIntegration } from "../../../../api/integrations/put-integration";
import { GreenCheckIcon } from "../../../../images/Icons/GreenCheckIcon";

interface HeatmapIntegrationProps {
  heatmapIntegration?: BaseIntegrationDto;
}

export const HeatmapIntegration = ({
  heatmapIntegration,
}: HeatmapIntegrationProps) => {
  const putIntegration = usePutIntegration();
  const disableIntegration = useDisableIntegration();

  const onEnableClick = (action: "new" | "delete") => {
    if (action === "new") {
      putIntegration.mutate({
        body: {
          name: "Heatmap",
        },
        pathParams: undefined,
        queryParams: undefined,
      });
    } else if (heatmapIntegration?.id) {
      disableIntegration.mutate({
        body: undefined,
        pathParams: {
          id: heatmapIntegration?.id,
        },
        queryParams: undefined,
      });
    }
  };

  return (
    <IgPaper sx={{ border: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container alignItems={"center"}>
            {heatmapIntegration?.enabled ? (
              <Grid item sx={{ marginRight: "15px", marginTop: "6px" }}>
                <GreenCheckIcon />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                sx={{
                  lineHeight: "26px",
                  letterSpacing: "0.5px",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Heatmap.com
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgButton
            variant={"contained"}
            loading={putIntegration.isPending || disableIntegration.isPending}
            onClick={() =>
              onEnableClick(heatmapIntegration?.enabled ? "delete" : "new")
            }
          >
            {heatmapIntegration?.enabled ? "Disable" : "Enable"}
          </IgButton>
        </Grid>
        {/*{heatmapIntegration && heatmapIntegration?.enabled ? (*/}
        {/*  <Grid container item direction={"column"}>*/}
        {/*    <Grid item>*/}
        {/*      <IgDivider spacing={"s"} />*/}
        {/*    </Grid>*/}
        {/*    <Grid container item alignItems={"center"} columnSpacing={2}>*/}
        {/*      <IgAlertSimple*/}
        {/*        severity={"warning"}*/}
        {/*        message={*/}
        {/*          <IgTypography>*/}
        {/*            <IgTypography sx={{ fontWeight: 600 }}>*/}
        {/*              Previously Integrated Heatmap.com using our docs?*/}
        {/*            </IgTypography>*/}
        {/*            <IgTypography>*/}
        {/*              {" "}*/}
        {/*              Be sure to remove the script from your website to avoid*/}
        {/*              double-tagging events.*/}
        {/*            </IgTypography>*/}
        {/*          </IgTypography>*/}
        {/*        }*/}
        {/*        alertKey={`clarity-warning`}*/}
        {/*      />*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*) : null}*/}
      </Grid>
    </IgPaper>
  );
};
